export default () => {
	return (
		<svg width="22" height="42" viewBox="0 0 22 42" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.3136 14.5327V9.33888H19.0085V14.5327H16.7712L13.3644 17.8787V7.89061H11.178V0H10.8729V7.89061H8.63559V17.8787L5.22881 14.5327H2.99153V9.33888H2.68644V14.5327H0.5V27.9667H2.68644V35.258H2.99153V27.9667H5.22881V20.0761L8.63559 23.4221V31.912H10.8729V42H11.178V31.912H13.3644V23.4221L16.7712 20.0761V27.9667H19.0085V35.258H19.3136V27.9667H21.5V14.5327H19.3136Z"
				fill="white"/>
		</svg>
	)
}